<ng-template let-item>
    <span class="text-value">
        <app-text-value-getter [item]="item" [path]="path"></app-text-value-getter>
    </span>
</ng-template>
